import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';

@Component({
  selector: 'bhub-login-failed',
  imports: [],
  templateUrl: './failed.component.html',
  styleUrl: './failed.component.scss'
})
export class FailedComponent extends BasePageComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
